<!-- AP deformity mechanical measures table -->
@if (hasAP()) {
<div class="box-table mb-5">
	<table aria-label="AP mechanical measures" class="table m-0">
		<thead>
			<tr>
				<th>{{ labels().VIEW_DEFORMITY_COMPONENT_MA_AP_HEADER }} <br />
					({{ (isLeft() ? sideEnum.Left : sideEnum.Right) | anatomicalSideLabel }})</th>
				<th>{{ labels().VIEW_DEFORMITY_COMPONENT_VALUE }}</th>
				<th>{{ labels().VIEW_DEFORMITY_COMPONENT_CONTROLATERAL }} <br />
					({{ (isLeft() ? sideEnum.Right : sideEnum.Left) | anatomicalSideLabel }})</th>
			</tr>
		</thead>
		<tbody>
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_MAD }} ({{apAngles.MAD.min}}mm - {{apAngles.MAD.max}}mm) </td>
				<td>{{ apMeasures()?.def_ap_MAD }}</td>
				<td>{{ ctrlMeasures()?.def_ap_MAD_ctrlateral }}</td>
			</tr>
			}
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_MNSA }} ({{apAngles.MNSA.min}}° - {{apAngles.MNSA.max}}°)</td>
				<td>{{ apMeasures()?.def_ap_MNSA }}</td>
				<td>{{ ctrlMeasures()?.def_ap_MNSA_ctrlateral }}</td>
			</tr>
			}
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_LPFA }} ({{apAngles.mLPFA.min}}° - {{apAngles.mLPFA.max}}°)</td>
				<td>{{ apMeasures()?.def_ap_LPFA }}</td>
				<td>{{ ctrlMeasures()?.def_ap_LPFA_ctrlateral }}</td>
			</tr>
			}
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_MPFA }} ({{apAngles.MPFA.min}}° - {{apAngles.MPFA.max}}°)</td>
				<td>{{ apMeasures()?.def_ap_MPFA }}</td>
				<td>{{ ctrlMeasures()?.def_ap_MPFA_ctrlateral }}</td>
			</tr>
			}
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_MLDFA }} ({{apAngles.mLDFA.min}}° - {{apAngles.mLDFA.max}}°)</td>
				<td>{{ apMeasures()?.def_ap_mLDFA }}</td>
				<td>{{ ctrlMeasures()?.def_ap_mLDFA_ctrlateral }}</td>
			</tr>
			}
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_KNEE_JLCA }} ({{apAngles.JLCA.min}}° - {{apAngles.JLCA.max}}°)</td>
				<td>{{ apMeasures()?.def_ap_JLCA }}</td>
				<td>{{ ctrlMeasures()?.def_ap_JLCA_ctrlateral }}</td>
			</tr>
			}
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_KNEE_TRANSL }} ({{apAngles.KneeTransl.min}}mm -
					{{apAngles.KneeTransl.max}}mm)</td>
				<td>{{ apMeasures()?.def_ap_kneeTranslation }}</td>
				<td>{{ ctrlMeasures()?.def_ap_kneeTranslation_ctrlateral }}</td>
			</tr>
			}
			@if (isLongLeg() || isTibia()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_MPTA }} ({{apAngles.MPTA.min}}° - {{apAngles.MPTA.max}}°)</td>
				<td>{{ apMeasures()?.def_ap_MPTA }}</td>
				<td>{{ ctrlMeasures()?.def_ap_MPTA_ctrlateral }}</td>
			</tr>
			}
			@if (isLongLeg() || isTibia()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_LDTA }} ({{apAngles.LDTA.min}}° - {{apAngles.LDTA.max}}°)</td>
				<td>{{ apMeasures()?.def_ap_LDTA }}</td>
				<td>{{ ctrlMeasures()?.def_ap_LDTA_ctrlateral }}</td>
			</tr>
			}
		</tbody>
	</table>
</div>

<!-- LLD measures table -->
<div class="box-table mb-5">
	<table aria-label="LLD measures" class="table m-0">
		<thead>
			<tr>
				<th></th>
				<th>{{ labels().VIEW_DEFORMITY_COMPONENT_LENGTH_HEADER }} <br />
					({{ (isLeft() ? sideEnum.Left : sideEnum.Right) | anatomicalSideLabel }})</th>
				<th>{{ labels().VIEW_DEFORMITY_COMPONENT_CL_LENGTH_HEADER }} <br />
					({{ (isLeft() ? sideEnum.Right : sideEnum.Left) | anatomicalSideLabel }})</th>
				<th>{{ labels().VIEW_DEFORMITY_COMPONENT_LLD_HEADER }}</th>
			</tr>
		</thead>
		<tbody>
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_LONGLEG }}</td>
				<td>{{ apMeasures()?.def_ap_fullLength }}</td>
				<td>{{ ctrlMeasures()?.def_ap_fullLength_ctrlateral }}</td>
				<td>{{ longlegLLD() }}</td>
			</tr>
			}
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_FEMUR }}</td>
				<td>{{ apMeasures()?.def_ap_femurLength }}</td>
				<td>{{ ctrlMeasures()?.def_ap_femurLength_ctrlateral }}</td>
				<td>{{ femurLLD() }}</td>
			</tr>
			}
			@if (isLongLeg() || isTibia()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_TIBIA }}</td>
				<td>{{ apMeasures()?.def_ap_tibiaLength }}</td>
				<td>{{ ctrlMeasures()?.def_ap_tibiaLength_ctrlateral }}</td>
				<td>{{ tibiaLLD() }}</td>
			</tr>
			}
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_FEMUR_TIBIA }}</td>
				<td>{{ trueLength() }}</td>
				<td>{{ trueLengthCL() }}</td>
				<td>{{ trueLengthLLD() }}</td>
			</tr>
			}
		</tbody>
	</table>
</div>
}

<!-- LT deformity mechanical measures table -->
@if (hasLT()) {
<div class="box-table mb-5">
	<table aria-label="LT mechanical measures" class="table m-0">
		<thead>
			<tr>
				<th>{{ labels().VIEW_DEFORMITY_COMPONENT_MA_LT_HEADER }} <br />
					({{ (isLeft() ? sideEnum.Left : sideEnum.Right) | anatomicalSideLabel }})</th>
				<th>{{ labels().VIEW_DEFORMITY_COMPONENT_VALUE }}</th>
			</tr>
		</thead>
		<tbody>
			@if (isLongLeg() || isFemur()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_PDFA }} ({{ltAngles.PDFA.min}}° - {{ltAngles.PDFA.max}}°)</td>
				<td>{{ ltMeasures()?.def_lt_PDFA }}</td>
			</tr>
			}
			@if (isLongLeg()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_KNEE_TRANSL }} ({{ltAngles.KneeTransl.min}}mm -
					{{ltAngles.KneeTransl.max}}mm)</td>
				<td>{{ ltMeasures()?.def_lt_kneeTranslation }}</td>
			</tr>
			}
			@if (isLongLeg() || isTibia()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_PPTA }} ({{ltAngles.PPTA.min}}° - {{ltAngles.PPTA.max}}°)</td>
				<td>{{ ltMeasures()?.def_lt_PPTA}}</td>
			</tr>
			}
			@if (isLongLeg() || isTibia()) {
			<tr>
				<td>{{ labels().VIEW_DEFORMITY_COMPONENT_ADTA }} ({{ltAngles.ADTA.min}}° - {{ltAngles.ADTA.max}}°)</td>
				<td>{{ ltMeasures()?.def_lt_ADTA }}</td>
			</tr>
			}
		</tbody>
	</table>
</div>
}

<!-- Apex measures table -->
<div class="box-table">
	<table aria-label="Apex measures" class="table m-0">
		<thead>
			<tr>
				<th>{{ labels().VIEW_DEFORMITY_COMPONENT_APEX_HEADER }}</th>
				@if (hasAP()) { <th>{{ labels().VIEW_DEFORMITY_COMPONENT_AP_HEADER }}</th> }
				@if (hasLT()) { <th>{{ labels().VIEW_DEFORMITY_COMPONENT_LT_HEADER }}</th> }
				<th>{{ labels().VIEW_DEFORMITY_COMPONENT_AXIAL_HEADER }}</th>
			</tr>
		</thead>
		<tbody>
			@if (isFemur() || isLongLeg()) {
			<tr>
				<td>{{ labels().APEX_TABLE_FEMUR }}</td>
				@if (hasAP()) { <td>{{ apFemurMeasure() }}</td> }
				@if (hasLT()) { <td></td> }
				<td>{{ axRotFemurMeasure() }}</td>
			</tr>
			}
			@if (isTibia() || isLongLeg()) {
			<tr>
				<td>{{ labels().APEX_TABLE_TIBIA }}</td>
				@if (hasAP()) { <td>{{ apTibiaMeasure() }}</td> }
				@if (hasLT()) { <td>{{ ltTibiaMeasure() }}</td> }
				<td>{{ axRotTibiaMeasure() }}</td>
			</tr>
			}
		</tbody>
	</table>
</div>